<div class="table-responsive m-b-2">
    <table class="w-100" cellspacing="0">
        <tbody>
            <tr>
                <td>Property UID</td>
                <td>{{response.property_uid || '-'}}</td>
            </tr>
            <tr>
                <td>Apartment Rental Higher Range</td>
                <td>{{response.apartment_rental_higher_range ? (response.apartment_rental_higher_range | number : "1.0-1") : '-'}}</td>
            </tr>
            <tr>
                <td>Apartment Rental Lower Range</td>
                <td>{{response.apartment_rental_lower_range ? (response.apartment_rental_lower_range | number : "1.0-1") : '-'}}</td>
            </tr>
            <tr>
                <td>Apartment Rental Midpoint</td>
                <td>{{response.apartment_rental_midpoint  ? (response.apartment_rental_midpoint | number : "1.0-1" ) : '-'}}</td>

            </tr>
            <tr>
                <td>Average Growth Rate</td>
                <td>
                    <table class="child-table growth-rate w-100" cellspacing="0">
                        <thead>
                            <tr>
                                @for (agrKey of response.average_growth_rate | keyvalue ; track $index) {
                                <th>{{agrKey.key}}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (agrVal of response.average_growth_rate | keyvalue ; track $index) {
                            <td>{{agrVal.value ? agrVal.value : '-'}}</td>
                            }
                        </tbody>
                    </table>
                </td>
            </tr>

            <tr>
                <td>Street Data</td>
                <td>
                    <table class="child-table w-100" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Road Name</th>
                                <th>Category</th>
                                <th>Distance</th>
                                <th>Road Width</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (street of response.street_data || []; track street) {
                            <tr>
                                <td>{{ street.road_name?street.road_name : '-' }}</td>
                                <td>{{ street.category?street.category : '-' }}</td>
                                <td>{{ street.distance?street.distance : '-' }}</td>
                                <td>{{ street.road_width?street.road_width : '-' }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</div>